import { useState } from "react";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { ShieldAlert, LogOut } from "lucide-react";

export default function ImpersonationBanner() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const [exiting, setExiting] = useState(false);
  const [error, setError] = useState("");

  if (!user || !user.is_impersonating) return null;

  const handleExit = async () => {
    setExiting(true);
    setError("");
    try {
      await api.post("/superadmin/exit-impersonation");
      await refresh();
      navigate("/admin");
    } catch (e) {
      setError(formatApiError(e));
    } finally {
      setExiting(false);
    }
  };

  return (
    <div
      className="sticky top-0 z-40 flex items-center justify-between gap-3 px-4 md:px-6 py-2.5"
      style={{
        background: "#E8A838",
        color: "#3B2F1E",
        borderBottom: "1px solid rgba(59,47,30,0.2)",
      }}
      data-testid="impersonation-banner"
    >
      <div className="flex items-center gap-2 min-w-0">
        <ShieldAlert size={18} />
        <span className="text-sm md:text-base font-medium truncate" data-testid="impersonation-banner-text">
          You are viewing as <strong>{user.impersonating_stable_name}</strong>
        </span>
      </div>
      <div className="flex items-center gap-3">
        {error && <span className="text-xs" style={{ color: "#922B21" }}>{error}</span>}
        <button
          onClick={handleExit}
          disabled={exiting}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-semibold"
          style={{ background: "#3B2F1E", color: "#F5EFE6" }}
          data-testid="impersonation-banner-exit"
        >
          <LogOut size={14} />
          {exiting ? "Exiting…" : "Exit"}
        </button>
      </div>
    </div>
  );
}
